import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { AlertDialogService } from '../../Services/Alert/alert.service'
import { CommonService } from '../../Services/Common/common.service'
import { PropertiesService } from '../Properties/properties.service';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {

  constructor(private httpclient: HttpClient,
    private alert: AlertDialogService,
    public commonService: CommonService,private property:PropertiesService) { }



  addStaticFields(body) {
      body.createdId =this.property.userId;
    // body.createdDateTime = this.commonService.getCurrentDate(),
      body.createdMacAddress = "FF.FFF.FF",
      body.modifiedId =this.property.userId,
      // body.modifiedDateTime = this.commonService.getCurrentDate(),
      body.modifiedMacAddress = "fffffff"
    return body;
  }

  get(uri) {
    return new Promise((resolve, reject) => {
      this.httpclient.get(uri, { responseType: 'json' }).subscribe((res: any) => {
      console.log("success", res);
        resolve(res);
      }, (error: any) => {
        console.log("failliure", error);
        this.alert.openSnackBar(error.error, '');
        reject(error);
      });
    });
  }
  post(uri, body, header?) {

    body = this.addStaticFields(body);
    return new Promise((resolve, reject) => {
      this.httpclient.post(uri, body, {headers: header, responseType: 'json' }).subscribe((res: any) => {
        console.log("success", res);
        resolve(res);
      }, (error: any) => {
        console.log("failure",error);
        if (error.error) {
          let message = error.error.result;
          this.alert.openSnackBar(message, '');
        }
        reject(error);
      });
    });

  }
  postBSS(uri, body, header?) {

    //body = this.addStaticFields(body);
    return new Promise((resolve, reject) => {
      this.httpclient.post(uri, body, {headers: header, responseType: 'json' }).subscribe((res: any) => {
        console.log("success", res);
        resolve(res);
      }, (error: any) => {
        console.log("failure",error);
        if (error.error) {
          let message = error.error.result;
          this.alert.openSnackBar(message, '');
        }
        reject(error);
      });
    });

  }
  put(uri, body) {
    body = this.addStaticFields(body);
    return new Promise((resolve, reject) => {
      this.httpclient.put(uri, body, { responseType: 'json' }).subscribe((res: any) => {
        console.log("success", res);
        resolve(res);
      }, (error: any) => {
        console.log("failure",error);
        if (error.error) {
          let message = error.error.result;
          this.alert.openSnackBar(message, '');
        }
        reject(error);
      });
    });
  }
  delete(uri) {
    return new Promise((resolve, reject) => {
      this.httpclient.delete(uri, { responseType: 'json' }).subscribe((res: any) => {
        console.log("success", res);
        resolve(res);
      }, (error: any) => {
        console.log("failure",error);
        this.alert.openSnackBar(error.error, '');
        reject(error);
      });
    });
  }
}

